<template>
  <div>
    <el-form-item label="最大值">
      <el-input-number v-model="activeData.max" placeholder="最大输入值" />
    </el-form-item>
    <el-form-item label="最小值">
      <el-input-number v-model="activeData.min" placeholder="最小输入值" />
    </el-form-item>
    <el-form-item label="步长">
      <el-input-number v-model="activeData.step" placeholder="输入每次增加的数值" />
    </el-form-item>
    <el-form-item label="精度">
      <el-input-number v-model="activeData.step" placeholder="请输入最多保留几位小数" />
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'ConfigItemNumber',
  props: ['activeData']
}
</script>

<style scoped></style>
